"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const ConsoleLogDestination_1 = require("./ConsoleLogDestination");
const Logger_1 = require("./Logger");
const isProd = process.env.NODE_ENV === 'production';
const destinations = [];
if (!isProd) {
    destinations.push(new ConsoleLogDestination_1.ConsoleLogDestination());
}
exports.logger = new Logger_1.Logger(destinations);
